// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/section_release_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { SectionReleaseService } from "./section_release_service_pb";

/**
 * @generated from rpc bffuser.v1.SectionReleaseService.GetSectionRelease
 */
export const getSectionRelease = SectionReleaseService.method.getSectionRelease;
